import { useQuery } from "@tanstack/react-query";

import { getForeignWorkersByOrganization } from "../../services/foreign_workers";

import { EtyForeignWorker } from "../../interfaces/entities";

const useGetForeignWorkersByOrganization = () => {
    const queryFn = async (): Promise<EtyForeignWorker[]> => {
        return await getForeignWorkersByOrganization();
    };

    return useQuery({
        queryKey: ['workers_for_organization'],
        queryFn,
        retry: 0,
    });
};

export default useGetForeignWorkersByOrganization;